import axios from "axios";

const service = axios.create({
  baseURL: "https://hai.haiquan.fun/wwwapi",
  //   process.env.NODE_ENV === "production"
  //     ? "https://hai.haiquan.fun/wwwapi" // 生产环境用线上地址
  //     : "http://192.168.2.136:8999/wwwapi", // 开发环境用测试/内网地址W
  // // "http://192.168.2.134:8999/wwwapi", // 开发环境用测试/内网地址Z
  
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

service.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token");
    // if (token) {
    //   config.headers["Authorization"] = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    console.error("请求错误:", error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const { data } = response;

    // 不管code是什么都正常返回数据，让业务代码自己处理
    return data;
  },
  (error) => {
    console.error("响应错误:", error);

    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          localStorage.removeItem("token");
          window.location.href = "/login";
          break;
        case 403:
          console.error("权限不足");
          break;
        case 404:
          console.error("请求的资源不存在");
          break;
        case 500:
          console.error("服务器内部错误");
          break;
        default:
          console.error(`请求失败: ${data?.message || error.message}`);
      }
    } else if (error.request) {
      console.error("网络错误，请检查网络连接");
    } else {
      console.error("请求配置错误:", error.message);
    }

    return Promise.reject(error);
  }
);

export default service;
